module.exports = __webpack_public_path__ + "img/16手机.2190a16a.png";